import { render, staticRenderFns } from "./RailResponsePresentation.vue?vue&type=template&id=630388ca&scoped=true&"
import script from "./RailResponsePresentation.vue?vue&type=script&lang=js&"
export * from "./RailResponsePresentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630388ca",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VDivider,VRow,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('630388ca')) {
      api.createRecord('630388ca', component.options)
    } else {
      api.reload('630388ca', component.options)
    }
    module.hot.accept("./RailResponsePresentation.vue?vue&type=template&id=630388ca&scoped=true&", function () {
      api.rerender('630388ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/OfferPresentation/RailResponsePresentation.vue"
export default component.exports